'use client'

import React, {useState} from 'react'
import {Inter} from 'next/font/google'
import {SessionProvider} from 'next-auth/react'

import {CookiesProvider} from 'react-cookie'
import {ThemeProviders} from '../hooks/themeProviders'
import '../styles/globals.css'

import {QueryClientProvider} from 'react-query';
import queryClient from '@api/query-client';

const inter = Inter({subsets: ['latin']})

interface RootLayoutProps {
    children: React.ReactNode
}

// https://nextjs.org/docs/app/api-reference/file-conventions/layout#root-layouts
// https://next-auth.js.org/getting-started/client#sessionprovider
function RootLayout({children}: RootLayoutProps) {
    let [session, setSession] = useState(undefined);

    return (
        <html lang="en">
            <body className={inter.className}>
                <SessionProvider session={session}>
                    <CookiesProvider>
                        <ThemeProviders>
                            <QueryClientProvider client={queryClient}>
                                {children}
                            </QueryClientProvider>
                        </ThemeProviders>
                    </CookiesProvider>
                </SessionProvider>
            </body>
        </html>
    )
}

export default RootLayout
